<div class="table-container" #tableHolder>
  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th class="col-1">
          <input (change)="selectAll($event)" type="checkbox" [checked]="isAllSelected"/>
        </th>
        <th class="">
          <span>Торгова назва</span>
          <app-input placeholder="Торгова назва"></app-input>
        </th>
        <th>Серія/Каталожний номер</th>
        <th>Придатний до</th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let product of paginatedProducts">
        <td class="col-1">
          <input
              type="checkbox"
              (change)="selectCurrent(product, $event)"
              [checked]="isSelectedItem(product)"
          />
        </td>
        <td>{{ product.tradeName }}</td>
        <td>{{ product.series }}</td>
        <td>{{ product.dueDate  | date: 'dd.MM.y'}}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <div class="table-footer" *ngIf="products.length">
    <med-pagination
        [perPage]="itemsPerPage"
        [total]="products.length"
        [page]="currentPage"
        (pageChange)="onPageChange($event)"
    />
  </div>
</div>
<app-loading-animation *ngIf="isLoading"></app-loading-animation>
